import React from "react";
import { Container } from "reactstrap";
import styles from "./footer.module.scss";

const Footer = () => (
    <div className={`section violet ${styles.footer}`}>
        <Container>
            <span>© PowerPlayers, 2018</span>
        </Container>
    </div>
);

export default Footer;
